import { ReactNode } from "react";
import classNames from "classnames";

import styles from "./style.module.scss";
import { CardVariant } from "types";
export interface ReviewHeaderTitleProps {
  icon: ReactNode;
  cardVariant: CardVariant;
  title: string;
}



const ReviewHeaderTitle = ({
  icon,
  title,
  cardVariant,
}: ReviewHeaderTitleProps) => {
  const headerTitleClassnames = classNames(styles.headerTitle, {
    [styles.exportHeaderTitle]: cardVariant === CardVariant.SELECTED,
    [styles.similarityHeaderTitle]: cardVariant === CardVariant.VERTEX,
  });

  return (
    <div className={headerTitleClassnames} data-testid={"title-header"}>
      <div className={styles.titleIcon}>{icon}</div>
      <div
        className={styles.titleContainer}
        title={title}
      >
        {title}
      </div>
    </div>
  );
};

export default ReviewHeaderTitle;
